/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var pliObservable = require("../forms-knockoutcontrols");
var picklistBehaviour = require("./knockoutControlsPicklist").behaviours.picklist;

module.exports = pliObservable.behaviours.picklist = picklistBehaviour;




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols-picklist/index.js
// module id = 25
// module chunks = 49